import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import { Button, TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Tooltip } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCustomers, getRPTSumTotalInv, getSaleType, getInventory } from "../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */

import { useTranslation } from "react-i18next";
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

export default function RPTSumTotalInv() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const location = useLocation();
  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading, filter } = useParamFilter(
    { page: 1, per_page: 300, start_date: moment().startOf("month").format("YYYY-MM-DD"), end_date: moment().endOf("month").format("YYYY-MM-DD") },
    getRPTSumTotalInv
  );
  // state
  const [input, setInput] = useState({
    start_date: filter.start_date || moment().startOf("month").format("YYYY-MM-DD"),
    end_date: filter.end_date || moment().endOf("month").format("YYYY-MM-DD"),
    inventory: null,
    customer: null,
    saletype: [],
    // productunit: []
  });
  const handleSearch = () => {
    fetchData((prev) => ({
      ...input,
      customer_id: input.customer?.id,
      customer: null,
      inventory_id: input.inventory?.id,
      inventory: null,
      saletype_id: input.saletype?.length ? JSON.stringify(input.saletype.map((i) => i.id)) : null,
      saletype: null,
    }));
  };

  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch(setHeaderTitle("BẢNG KÊ TỔNG HỢP SỐ LIỆU XUẤT HOÁ ĐƠN"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getInventory({ status: 1 })}
            value={input.inventory || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue }))}
            label={t("Kho hàng")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id == filter.inventory_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.inventory_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.customer || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
            label={t("Khách hàng")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == filter.customer_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.customer_id]}
          />
          <CustomDatePicker label={t("Từ ngày")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <CustomDatePicker label={t("Đến ngày")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            multiple
            getDataFunc={() => getSaleType({ status: 1 })}
            value={input.saletype}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, saletype: newValue }))}
            label={t("Loại hình bán")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, saletype: option.filter((item) => JSON.parse(filter.saletype_id).find((i) => i == item.id)) }))}
            triggerSetDefaultFunc={Boolean(filter.saletype_id)}
            setDefaultDependencies={[filter.saletype_id]}
          />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }} rowSpan={2}>
                      STT
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }} colSpan={6}>
                      Thông tin chung
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }} colSpan={3}>
                      Ngoại tệ (USD)
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }} colSpan={3}>
                      Nội tệ (VND)
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="center" style={{ border: "1px solid lightgray", minWidth: 250 }}>
                      Khách hàng
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", minWidth: 200 }}>
                      Hãng bay
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Phương thức bán
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      ∑ (USG)
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      ∑ (Lit)
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      ∑ (Kg)
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Tổng tiền
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      VAT
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Thành tiền
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Tổng tiền
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      VAT
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                      Thành tiền
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {index + (+filter.page - 1) * filter.per_page + 1}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.customer_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.airline_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.component}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.sub_gallon?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.sub_lit?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.sub_kg?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency !== "VND" && item.sub_amount?.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency !== "VND" && item.vat?.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency !== "VND" && item.total?.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency === "VND" && item.sub_amount?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency === "VND" && item.vat?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.currency === "VND" && item.total?.toLocaleString()}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                  {Boolean(data?.length) && (
                    <TableRow>
                      <TableCell style={{ border: "1px solid lightgray" }} align="center" colSpan={4}>
                        Tổng cộng
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + c.sub_gallon, 0).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + c.sub_lit, 0).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + c.sub_kg, 0).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency !== "VND" ? c.sub_amount : 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency !== "VND" ? c.vat : 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency !== "VND" ? c.total : 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency === "VND" ? c.sub_amount : 0), 0).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency === "VND" ? c.vat : 0), 0).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {data.reduce((p, c) => p + (c.currency === "VND" ? c.total : 0), 0).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
}
